export enum SelectionSubmissionSource {
	InPerson = 'InPerson',
	Realtor = 'Realtor',
	Purchaser = 'Purchaser'
}